import { atom, type ReadableAtom } from 'nanostores';

const _descriptionStore = atom<string | undefined>();

export const descriptionStore = _descriptionStore as ReadableAtom<string | undefined>;

export function setDescription(description: string | undefined) {
  _descriptionStore.set(description);
}

export function getDescription() {
  return descriptionStore.get();
}
